/* eslint-disable no-param-reassign */
export default (state, action) => {
  const { id, completedChunk } = action.payload;
  if (state[id]) {
    state[id].uploadSize += completedChunk;
  }
};
